import React from 'react';
import classNames from 'classnames';
import { Icon } from 'ui';
import { TYPES } from 'constants/config';
import request from 'utils/request_ajax';

class RelatedUrlMapping extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lessonSections: null,
      error: false,
    };
    this.add = this.add.bind(this);
    this.delete = this.delete.bind(this);
    this.updateSelectionTitle = this.updateSelectionTitle.bind(this);
    this.fetchLessonSections = this.fetchLessonSections.bind(this);
  }

  delete() {
    this.props.deleteMapping(this.props.mapping);
  }

  add() {
    this.props.addNewMapping(this.props.mapping);
  }

  updateSelectionTitle(e) {
    this.props.updateMapping({
      ...this.props.mapping,
      selectedSection: { id: e.target.value },
    });
  }

  fetchLessonSections() {
    request
      .get('/lessons/' + this.props.mapping.learningContentId + '/sections')
      .then(payload => {
        this.setState({
          lessonSections: payload,
          error: false,
        });
      })
      .fail(error => {
        this.setState({
          error: true,
        });
      });
  }

  UNSAFE_componentWillUpdate({ editing, mapping }, state) {
    if (
      editing &&
      mapping.learningContentType === TYPES.LESSON &&
      !state.lessonSections &&
      !this.state.error
    ) {
      this.fetchLessonSections();
    }
  }

  componentDidMount() {
    if (
      this.props.editing &&
      this.props.mapping.learningContentType === TYPES.LESSON &&
      !this.state.lessonSections
    ) {
      this.fetchLessonSections();
    }
  }

  render() {
    const { mapping, editing, i18n } = this.props;
    const contentUrl = mapping.learningContentOverviewUrl;
    const groups = mapping.groups || [];
    const groupNames = groups.map(group => group.name).join(', ');
    const tableRowClasses = classNames('FlexboxTable-row', {
      'FlexboxTable-row--withBottomBorder': editing,
    });

    const externalLink = () => (
      <div>
        <div className="mb-8">
          <div className="HelpText HelpText--muted">
            {i18n.external_link.name}
          </div>
          <a href={contentUrl}>{mapping.learningContentTitle}</a>
        </div>

        <div className="mb-8">
          <div className="HelpText HelpText--muted">
            {i18n.external_link.description}
          </div>
          <div className="ws-pr">{mapping.learningContentDescription}</div>
        </div>
      </div>
    );

    const learningContent = () => (
      <div>
        {mapping.learningContentType === TYPES.PATH && (
          <Icon name="path" className="mr-4" />
        )}
        {contentUrl && <a href={contentUrl}>{mapping.learningContentTitle}</a>}
        {!contentUrl && <span>{mapping.learningContentTitle}</span>}
      </div>
    );

    return (
      <div className={tableRowClasses}>
        <div className="FlexboxTable-cell d-f jc-sb ai-c">
          <div>
            {mapping.learningContentType === TYPES.EXTERNAL_LINK &&
              externalLink()}
            {mapping.learningContentType !== TYPES.EXTERNAL_LINK &&
              learningContent()}
            {typeof mapping.lessonsCount === 'number' && (
              <div className="HelpText HelpText--muted HelpText--noTopMargin">
                {mapping.lessonsCount} {i18n.lessons}
              </div>
            )}
            <div>
              {!editing && mapping.selectedSection && (
                <div className="HelpText HelpText--muted HelpText--noTopMargin">
                  § {mapping.selectedSection.title || i18n.untitled_section}
                </div>
              )}
              {editing && mapping.learningContentType === TYPES.LESSON && (
                <div className="mt-4">
                  <span className="HelpText HelpText--muted mr-4">
                    {i18n.link_to}
                  </span>
                  <select
                    defaultValue={
                      mapping.selectedSection && mapping.selectedSection.id
                    }
                    onChange={this.updateSelectionTitle}
                    disabled={!this.state.lessonSections}
                  >
                    <option value={null}>{i18n.lesson_start}</option>
                    {this.state.lessonSections && (
                      <optgroup label="Link to a section:">
                        {this.state.lessonSections.map(section => (
                          <option value={section.id} key={section.id}>
                            {section.title || i18n.untitled_section}
                          </option>
                        ))}
                      </optgroup>
                    )}
                  </select>
                  {this.state.error && (
                    <span className="ml-8 c-brand-red">
                      Something went wrong.
                      <button
                        onClick={this.fetchLessonSections}
                        type="button"
                        className="NewButton NewButton--gray c-brand-gray-darkest ml-4"
                      >
                        Try again
                      </button>
                    </span>
                  )}
                </div>
              )}
            </div>
          </div>
          {editing && (
            <div className="IndexAction-container">
              {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/anchor-is-valid */}
              <a
                className="ButtonWithTooltip IndexAction-button IndexAction-button--square"
                onClick={this.delete}
                data-tooltip="Delete Mapping"
              >
                <Icon name="delete" />
              </a>
            </div>
          )}
        </div>
        <div className="FlexboxTable-cell d-f ai-c">
          {groups.length > 0 && <Icon name="group" className="mr-8" />}
          {groupNames.length > 0 && <span>{groupNames}</span>}
          {!!mapping.groups && groupNames.length === 0 && (
            <em>{i18n.no_groups_placeholder}</em>
          )}
          {!mapping.groups && <em>{i18n.groups_placeholder}</em>}
        </div>
      </div>
    );
  }
}

export default RelatedUrlMapping;
